import React from 'react'
import { useTranslation } from 'react-i18next'
import { IComment } from 'src/service/api/api.types'
import Form from 'src/components/Curso/Classroom/Comments/Form'
import { IoArrowUndo } from 'react-icons/io5'
import { getImageUrl } from 'src/utils/getImageUrl'
import formatText from "src/utils/formatText";
import { Box, Image } from './styles'

interface Props {
  comment: IComment
  hasResponse: boolean
  idFather?: string
}

const CardComment: React.FC<Props> = props => {
  const { t } = useTranslation()
  const [isResponse, setIsResponse] = React.useState(false)

  const RenderCard = () => {
    const comment = {
      imageUrl: '',
      name: '',
      comment: '',

    }
    if(props.comment.teacher) {
      comment.imageUrl = props.comment.teacher.imageUrl
      comment.name = props.comment.teacher.name
      comment.comment = props.comment.comment
    }

    if(props.comment.isAdminReply && !props.comment.teacher) {
      comment.imageUrl = '/logo-static2.png'
      comment.name = t('classroom.comment.admResponse')
      comment.comment = props.comment.comment
    }

    if(!props.comment.isAdminReply && props.comment.user) {
      comment.imageUrl = props.comment.user.profilePhoto ? getImageUrl(props.comment.user.profilePhoto, 40, 40) : 'https://res.cloudinary.com/cordasemusica/image/upload/v1678224793/avatar-sem-bg_hopify.png'
      comment.name = props.comment.user.name
      comment.comment = props.comment.comment
    }

    return (
      <div className="card">
        <div className="card-header">
          <Image
            image={comment.imageUrl}
          >
            <div />
          </Image>
          <h3>
            {comment.name}
          </h3>
        </div>

        <div className="card-body">
          <div className="card-body-text">
            {formatText(comment.comment)}
            <div className="response-text">
                <span onClick={() => setIsResponse(true)}>
                  <IoArrowUndo /> {t('classroom.comment.response')}
                </span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return props.comment ? (
    <>
      <Box hasResponse={props.hasResponse || props.comment.isAdminReply}>
        <RenderCard />
      </Box>

      <div>
        {isResponse ? (
          <Form idParent={props.idFather} setIsResponse={setIsResponse} hasCardComment />
        ) : null}
      </div>
    </>
  ) : null
}

export default React.memo(CardComment)
